<div class="item p-3 my-auto">
  <form [formGroup]="recForm" (ngSubmit)="recuperarPassword()" class="mt-0">
    <h2 class=" mb-2 font-bold text-xl text-white">Olvido de contraseña</h2>
    <p class="mb-4 text-sm text-white fw-semibold" style="font-size: 16px !important;">
      No te preocupes todos olvidamos nuestras contraseñas. <br>
      Ingresa tu usuario y sigue las instrucciones.
    </p>

    <div class="form-field">
      <label for="user" class="form-label">Usuario</label>
      <input type="text" class="form-control" placeholder="*Número de cédula" id="user" formControlName="user"
        autocomplete="off">
      <div *ngIf="recForm.controls.user.hasError('pattern')" class=" form-error">
        Este campo solo acepta <strong>números</strong>
      </div>
      <div *ngIf="recForm.controls.user.hasError('minlength')" class="form-error">
        Minimo 8 caracteres
      </div>
      <div *ngIf="recForm.controls.user.hasError('maxlength')" class="form-error">
        Maximo 15 caracteres
      </div>
      <div *ngIf="recForm.controls.user.hasError('required') && !recForm.controls.user.pristine" class="form-error">
        El usuario es requerido
      </div>
    </div>
    <footer class="mt-4">
      <button-look-feel [type]="'submit'" [block]="true" color="secondary" [disabled]="!this.recForm.valid"
        customClass="py-2">Recuperar Contraseña</button-look-feel>
    </footer>
  </form>
  <div class="d-flex justify-content-center mt-3">
    <app-hyperlink-icon icon="arrow-left" (clicked)="goToHome()">Volver</app-hyperlink-icon>
  </div>
</div>